import axios from "axios";
import store from "redux/Store";
import { pagingTotalRelation } from "redux/Types";
import { v4 as uuidv4 } from "uuid";
var reducerModule = "/all-news";

export const actionTypes = {
  QUERY: "QUERY" + reducerModule,
  LOADING: "LOADING" + reducerModule,
  LATEST_LOADING: "LATEST_LOADING" + reducerModule,
  LOAD: "LOAD" + reducerModule,
  LATEST_LOAD: "LATEST_LOAD" + reducerModule,
  ERROR: "ERROR" + reducerModule,
  FOCUS_ITEM: "FOCUS_ITEM" + reducerModule,
  SELECT_ITEMS: "SELECT_ITEMS" + reducerModule,
  SELECT_PREVIEW_ITEM_LOADING: "SELECT_PREVIEW_ITEM_LOADING" + reducerModule,
  SELECT_PREVIEW_ITEM: "SELECT_PREVIEW_ITEM" + reducerModule
};



export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};

export const search = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .post(`${orgID}/news/allnewssearch`, query, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    });
};

export const searchLatest = (query = {}) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LATEST_LOADING,
  });

  axios
    .post(`${orgID}/news/latestnewssearch`, query, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LATEST_LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    });
};

export const previewItem = (item, singleView = false) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_PREVIEW_ITEM_LOADING,
  });

  setTimeout(() => {
    dispatch({
      type: actionTypes.SELECT_PREVIEW_ITEM,
      payload: item,
      singleView: singleView,
    });
  }, 0);
};

export const clearSelectedPreview = () => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_PREVIEW_ITEM,
    payload: [],
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};